import { GenerateProductsResponse } from '../Product.model';

export const isEmptyData = (data?: GenerateProductsResponse | null): boolean =>
  Boolean(!data?.zipFilePresignedUrl && !data?.csvFilePresignedUrl);
